import React from 'react';
import { useLocation } from '@reach/router';
import { RichTextBlock } from 'prismic-reactjs';
import Wrapper from '@components/wrapper.styled';
import Text from '@components/text';
import { StyledHeader, Constraint, Subheading } from './small-hero.styled';

interface SmallHeroProps {
  title?: string;
  subheading?: RichTextBlock[];
}

const SmallHero = ({ title, subheading = [] }: SmallHeroProps): JSX.Element => {
  const hasSubheading: boolean = subheading?.length > 0 && subheading[0].text !== '';
  const location = useLocation();
  const activeTag = new URLSearchParams(location.search).get('tag') || '';

  return (
    <StyledHeader>
      <Wrapper>
        <Constraint>
          {title && (
            <Text
              type="title"
              stringText={decodeURIComponent(activeTag) || title}
              fontSize="heading1"
              fontColor="white"
              margin="none"
            />
          )}
          {!activeTag && hasSubheading && <Subheading type="subheading" richText={subheading} />}
        </Constraint>
      </Wrapper>
    </StyledHeader>
  );
};

export default SmallHero;
